import React from "react";
import { FaCheck, FaEdit, FaTimes } from "react-icons/fa";

export default function TeacherAboutModal({
  isOpen,
  value,
  setValue,
  onClose,
  onSave,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-slate-950/55 px-4 backdrop-blur-sm">
      <button
        type="button"
        className="absolute inset-0 cursor-default"
        onClick={onClose}
        aria-label="Close about modal"
      />
      <div className="relative z-10 w-full max-w-2xl overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-[0_32px_90px_-35px_rgba(15,23,42,0.55)]">
        <div className="border-b border-slate-200 bg-slate-50 px-6 py-5">
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-slate-900 text-white">
                <FaEdit />
              </div>
              <h2 className="mt-4 text-2xl font-bold text-slate-900">Edit About You</h2>
              <p className="mt-2 max-w-xl text-sm leading-6 text-slate-600">
                Add a short introduction that describes you, your teaching style, or your subject focus.
              </p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-100"
              aria-label="Close modal"
            >
              <FaTimes />
            </button>
          </div>
        </div>

        <div className="grid gap-6 p-6 md:grid-cols-[0.9fr_1.1fr]">
          <div className="space-y-4">
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm leading-6 text-slate-600">
              This text appears on your teacher profile and gives it a more personal, real introduction.
            </div>
            <div className="space-y-3 text-sm leading-6 text-slate-600">
              <div className="rounded-2xl border border-slate-200 bg-white p-4">Mention your teaching approach, classroom values, or subject specialization.</div>
              <div className="rounded-2xl border border-slate-200 bg-white p-4">Keep it short and useful so it reads well in the profile header.</div>
            </div>
          </div>

          <div className="space-y-5">
            <div>
              <label className="mb-2 block text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">About You</label>
              <textarea
                value={value}
                onChange={(event) => setValue(event.target.value)}
                rows={7}
                maxLength={280}
                className="w-full resize-none rounded-2xl border border-slate-300 bg-white px-4 py-3 text-sm leading-6 text-slate-900 transition focus:border-slate-900 focus:outline-none focus:ring-2 focus:ring-slate-200"
                placeholder="Write a short introduction about yourself, your teaching style, or your subject focus."
                autoFocus
              />
              <p className="mt-2 text-xs text-slate-500">{value.trim().length}/280 characters</p>
            </div>

            <div className="flex flex-wrap gap-3">
              <button
                type="button"
                onClick={onSave}
                className="inline-flex items-center rounded-xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-800"
              >
                <FaCheck className="mr-2 text-xs" /> Save about text
              </button>
              <button
                type="button"
                onClick={onClose}
                className="inline-flex items-center rounded-xl border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}